import React, { useEffect, useRef, useState } from "react";
import "./profile.scss";
import Form from "devextreme-react/form";
import { Button } from "devextreme-react/button";
// import "devextreme/dist/css/dx.light.css"; // or another theme

import authApi from "api/authApi";
import { useFetch, usePut } from "@hooks/useAuthApi";
import Cookies from "js-cookie";
import "@common-components/cards/DarkCard.scss";
import { useNavigate } from "react-router-dom";

export default function Profile() {
  const navigate = useNavigate();

  const updateUserProfileMutation = usePut(
    "updateUserProfile",
    authApi.updateUserProfile
  );
  // const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const { data: userDetails, refetch } = useFetch(
    "getUserDetails",
    authApi.getUserDetails
  );

  const fileInputRef = useRef(null);

  const [isEditEnabled, setIsEditEnabled] = useState(false);
  const [fileInput, setFileInput] = useState(null);
  const [loader, setLoader] = useState(false);
  const [formData, setFormData] = useState({
    FirstName: userDetails?.data?.firstName || "-",
    LastName: userDetails?.data?.lastName || "-",
    Gender: userDetails?.data?.gender || "-", // Replace with userDetails?.data?.gender if available
    Country: userDetails?.data?.country || "-", // Replace if needed
    Department: userDetails?.data?.department || "-", // Replace with userDetails?.data?.department if available
    Position: userDetails?.data?.position || "-", // Replace if needed
    JoiningDate: userDetails?.data?.joiningDateUTC || "-", // Replace with actual if available
    Phone: userDetails?.data?.phoneNumber || "-",
    Email: userDetails?.data?.email || "-",
    role: userDetails?.data?.role || "-",
    Address: "4600 N Virginia Rd.", // Replace with actual if available
    imageURL: userDetails?.data?.imageURL || "-",
    UserID: userDetails?.data?.userID || "-",
  });

  useEffect(() => {
    setFormData({
      FirstName: userDetails?.data?.firstName || "-",
      LastName: userDetails?.data?.lastName || "-",
      Gender: userDetails?.data?.gender || "-", // Replace with userDetails?.data?.gender if available
      Country: userDetails?.data?.country || "-", // Replace if needed
      Department: userDetails?.data?.department || "-", // Replace with userDetails?.data?.department if available
      Position: userDetails?.data?.position || "-", // Replace if needed
      JoiningDate: userDetails?.data?.joiningDateUTC || new Date("2005/05/11"), // Replace with actual if available
      Phone: userDetails?.data?.phoneNumber || "-",
      Email: userDetails?.data?.email || "-",
      role: userDetails?.data?.role || "-",
      Address: userDetails?.data?.address || "4600 N Virginia Rd.", // Replace with actual if available
      imageURL: userDetails?.data?.imageURL || "-",
      UserID: userDetails?.data?.userID || "-",
    });
  }, [userDetails]);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileInput(file);
      setIsEditEnabled(true);
    }
  };

  const genderOptions = [
    { text: "Male", value: 1 },
    { text: "Female", value: 2 },
  ];
  const departmentOptions = ["IT", "HR", "Development", "Marketing"];
  const positionOptions = [
    "Manager",
    "Developer",
    "Controller",
    "Sr. UXUI & Front End Developer",
  ];

  const colCountByScreen = {
    xs: 1,
    sm: 1,
    md: 1,
    lg: 1,
  };

  const handleSave = async () => {
    console.log("Saved Data:", formData);
    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("accept", "text/plain");
    myHeaders.append("Authorization", `Bearer ${Cookies.get("accessToken")}`);

    const formdata = new FormData();
    formdata.append("Gender", formData.Gender);
    formdata.append("UserID", formData.UserID);
    formdata.append("Position", formData.Position);
    formdata.append("Department", formData.Department);
    formdata.append("ImageURL", formData.imageURL || "");
    formdata.append("Address", formData.Address);
    formdata.append("Country", formData.Country);
    formdata.append("PhoneNumber", formData.Phone);
    formdata.append("file", fileInput || "");
    formdata.append(
      "JoiningDateUTC",
      new Date(formData.JoiningDate).toISOString()
    );

    // const requestOptions = {
    //   method: "PUT",
    //   headers: myHeaders,
    //   body: formdata,
    //   redirect: "follow",
    // };

    try {
      await updateUserProfileMutation.mutateAsync({ data: formdata });
      refetch();
      setIsEditEnabled(false);
      setLoader(false);
    } catch (error) {}
  };

  return (
    <React.Fragment>
      <div className="content-block dx-card responsive-paddings">
        <div className="w-full flex items-center mt-2 mb-2">
          <div className="flex items-center mb-3 mr-2">
            <Button
              icon="back"
              type="normal"
              stylingMode="text"
              onClick={() => navigate(-2)}
            />
          </div>
          <p className="whitespace-nowrap text-xl font-medium">User Profile:</p>
          <div className="flex-grow h-[0.5px] bg-gray-300 ml-2 light-bg"></div>
        </div>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-5">
            <div
              className="form-avatar"
              onClick={handleImageClick}
              style={{ cursor: "pointer" }}
            >
              <img
                alt=""
                src={`${userDetails?.data?.imageURL || "/images/user-dummy.png"}`}
              />
              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleImageChange}
                style={{ display: "none" }}
              />
            </div>
            <div>
              <p className="mb-1 text-lg">{`${userDetails?.data?.firstName} ${userDetails?.data?.lastName}`}</p>
              <p className="mb-0 text-gray-400">
                ID: {userDetails?.data?.userID}
              </p>
            </div>
          </div>
          <Button
            className="profile-edit-button"
            width={100}
            text={loader ? "Saving" : "Save"}
            stylingMode="contained"
            type="default"
            useSubmitBehavior
            onClick={handleSave}
            disabled={!isEditEnabled}
          />
        </div>
        <Form
          id="form"
          formData={formData}
          labelLocation="top"
          showColonAfterLabel={false}
          colCountByScreen={colCountByScreen}
          onFieldDataChanged={(e) => {
            setIsEditEnabled(true);
            setFormData({
              ...formData,
              [e.dataField]: e.value,
            });
          }}
          items={[
            {
              itemType: "group",
              caption: "Basic Info",
              colCount: 2,
              items: [
                {
                  dataField: "FirstName",
                  label: { text: "First Name" },
                  editorOptions: { disabled: true },
                },
                {
                  dataField: "LastName",
                  label: { text: "Last Name" },
                  editorOptions: { disabled: true },
                },
                {
                  dataField: "Gender",
                  editorType: "dxSelectBox",

                  editorOptions: {
                    items: genderOptions,
                    placeholder: "Select gender",
                    displayExpr: "text", // what to show in dropdown
                    valueExpr: "value", // what to store in formData
                  },
                },
                {
                  dataField: "Country",
                  label: { text: "Country" },
                },
                {
                  dataField: "Department",
                  editorType: "dxSelectBox",
                  editorOptions: {
                    items: departmentOptions,
                    placeholder: "Select department",
                  },
                },
                {
                  dataField: "Position",
                  editorType: "dxSelectBox",
                  editorOptions: {
                    items: positionOptions,
                    placeholder: "Select position",
                  },
                },
                {
                  dataField: "JoiningDate",
                  label: { text: "Joining Date" },
                  editorType: "dxDateBox",
                  editorOptions: {
                    type: "date", // This tells it to show the calendar
                    // displayFormat: "yyyy-MM-dd", // Optional: how the date appears in the input
                    // openOnFieldClick: true, // Ensures clicking the input opens the picker
                    // showClearButton: true, // Optional: lets user clear the date
                    // placeholder: "Select a date",
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "Contact Info",
              colCount: 2,
              items: [
                { dataField: "Phone" },
                { dataField: "Email", editorOptions: { disabled: true } },
                {
                  dataField: "Address",
                  editorType: "dxTextArea",
                  colSpan: 2,
                },
              ],
            },
          ]}
        />
      </div>
    </React.Fragment>
  );
}
